import { useState } from "react";
import { toast } from "sonner";
import { Copy, Check } from "lucide-react";

export function CopyableField({ label, value, testid }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(String(value ?? ""));
      setCopied(true);
      toast.success(`${label} copiado`);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("No se pudo copiar");
    }
  };
  return (
    <div className="flex items-center gap-2 bg-[#0A0A0A] border border-[#262626] rounded-md px-3 py-2" data-testid={testid}>
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-wider text-neutral-500">{label}</div>
        <div className="font-mono text-sm text-white truncate select-all">{value || "—"}</div>
      </div>
      <button
        type="button"
        onClick={copy}
        disabled={!value}
        className="p-2 rounded-md hover:bg-[#171717] text-neutral-400 hover:text-white disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label={`Copiar ${label}`}
        data-testid={`${testid}-copy`}
      >
        {copied ? <Check size={14} className="text-emerald-400" /> : <Copy size={14} />}
      </button>
    </div>
  );
}

export default CopyableField;
